import React from 'react';
import { observer } from 'mobx-react-lite';
import { useRootStore } from 'store/rootStore';
import { useAddQuotePageStore } from 'store/pages/quote/add-quote/pageStore';
import UWGuidelines from 'components/common/general/UWGuidelines';
import DynamicFormModalDEPRECATED from 'components/common/modals/DynamicFormModal_DEPRECATED';
import AddQuoteMainInfo from './AddQuoteMainInfo';

import AddQuoteValidationAlert from './AddQuoteValidationAlert';
import { createStyles, PlansListStyled } from './styles';
import ProductLineSection from './AddQuoteProductLineSection';
import { ADD_QUOTE_TEST_IDS } from './constants';

const AddQuotePageContent: React.FC = observer(() => {
  const {
    productLineSections,
    uwGuidelines,
    isQuoteEditable,
    configurePlanModal,
    closeConfigurePlanModal,
    savePortfolioConfigChanges,
  } = useAddQuotePageStore();

  const { domainStoreV2 } = useRootStore();
  const classes = createStyles();

  return (
    <>
      <AddQuoteMainInfo />
      {domainStoreV2.showQuotingUWGuidelinesFeature && uwGuidelines.length > 0 ? (
        <UWGuidelines uwGuidelines={uwGuidelines} />
      ) : null}
      <PlansListStyled data-test-id={ADD_QUOTE_TEST_IDS.PLANS}>
        {productLineSections.map((sectionGroup) => (
          <ProductLineSection key={sectionGroup.section} sectionGroup={sectionGroup} />
        ))}
      </PlansListStyled>
      <AddQuoteValidationAlert />
      <DynamicFormModalDEPRECATED
        show={configurePlanModal.show}
        onClose={closeConfigurePlanModal}
        onAction={savePortfolioConfigChanges}
        dynamicForm={configurePlanModal.dynamicForm}
        form={configurePlanModal.form}
        loading={configurePlanModal.loading}
        isEditable={isQuoteEditable}
        formStyles={classes.bcForm}
      />
    </>
  );
});

export default AddQuotePageContent;
